(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const wrappers = document.querySelectorAll('.article-list-grid-wrapper');

    wrappers.forEach((wrapper) => {
      const grid = wrapper.querySelector('.article-list-blocks');
      const prevBtn = wrapper.querySelector('.carousel-prev');
      const nextBtn = wrapper.querySelector('.carousel-next');

      if (!grid || !prevBtn || !nextBtn) return;

      const scrollAmount = grid.clientWidth + 30;

      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        grid.scrollBy({
          left: -scrollAmount,
          behavior: 'smooth',
        });
      });

      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        grid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      const updateButtons = () => {
        const screenWidth = window.innerWidth;
        const isDesktopCarousel = screenWidth > 768 && grid.classList.contains('desktop-view-carousel');
        const isMobileCarousel = screenWidth <= 768 && grid.classList.contains('mobile-view-carousel');
        const isCarousel = isDesktopCarousel || isMobileCarousel;

        if (isCarousel) {
          prevBtn.classList.add('show');
          nextBtn.classList.add('show');

          setTimeout(() => {
            const scrollLeft = grid.scrollLeft;
            const scrollWidth = grid.scrollWidth;
            const clientWidth = grid.clientWidth;

            const isStart = scrollLeft <= 1;

            const isEnd = scrollLeft >= scrollWidth - clientWidth - 1;

            prevBtn.style.opacity = isStart ? '0.3' : '1';
            nextBtn.style.opacity = isEnd ? '0.3' : '1';
            prevBtn.disabled = isStart;
            nextBtn.disabled = isEnd;
          }, 50);
        } else {
          prevBtn.classList.remove('show');
          nextBtn.classList.remove('show');
        }
      };

      setTimeout(updateButtons, 200);

      grid.addEventListener('scroll', () => {
        setTimeout(updateButtons, 10);
      });

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateButtons, 200);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-selling"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.best-selling-tabs-block').forEach((tabsContainer) => {
      const tabLinks = tabsContainer.querySelectorAll('.tablinks');
      const tabItems = tabsContainer.querySelectorAll('.tab-item');

      tabLinks.forEach((link) => {
        link.addEventListener('click', function (e) {
          e.preventDefault();

          const targetId = this.dataset.tab;

          // Deactivate all tab links
          tabLinks.forEach((lnk) => lnk.classList.remove('active'));

          // Hide all tab items
          tabItems.forEach((item) => (item.style.display = 'none'));

          // Activate clicked tab
          this.classList.add('active');

          // Show the corresponding tab item
          const tabContent = tabsContainer.querySelector(`#${targetId}`);
          const tabItem = tabContent?.closest('.tab-item');
          if (tabItem) {
            tabItem.style.display = 'block';
          }
        });
      });

      // Optionally scroll-aware tab highlighting (for external usage)
      const sectionMap = {};
      tabItems.forEach((item) => {
        const tabMeta = item.querySelector('.tab-meta');
        if (tabMeta) {
          const id = tabMeta.dataset.id;
          sectionMap[id] = item;
        }
      });

      function updateActiveTabOnScroll() {
        let closestTabId = null;
        let minDistance = window.innerHeight;

        Object.entries(sectionMap).forEach(([tabId, section]) => {
          const rect = section.getBoundingClientRect();
          if (rect.top >= 0 && rect.top < minDistance) {
            minDistance = rect.top;
            closestTabId = tabId;
          }
        });

        if (closestTabId) {
          tabLinks.forEach((lnk) => lnk.classList.remove('active'));
          const activeLink = tabsContainer.querySelector(`[data-tab="${closestTabId}"]`);
          if (activeLink) {
            activeLink.classList.add('active');
          }
        }
      }
    });
  });
  (function () {
    'use strict';

    function initBestSellingSliders() {
      const sliderContainers = document.querySelectorAll('.best-selling-slider-container');

      sliderContainers.forEach(function (container) {
        // Skip if already initialized
        if (container.hasAttribute('data-slider-initialized')) return;
        container.setAttribute('data-slider-initialized', 'true');

        const wrapper = container.querySelector('.card-wrapper--slider');
        const prevBtn = container.querySelector('.slider-nav--prev');
        const nextBtn = container.querySelector('.slider-nav--next');
        const cardItems = wrapper ? wrapper.querySelectorAll('.card-item') : [];

        if (!wrapper || !prevBtn || !nextBtn || cardItems.length === 0) return;

        let currentIndex = 0;

        // Get visible card items based on screen size
        function getVisibleCards() {
          const isMobile = window.innerWidth < 768;
          const maxCards = isMobile ? 2 : 5;
          const visibleCards = [];

          for (let i = 0; i < Math.min(cardItems.length, maxCards); i++) {
            visibleCards.push(cardItems[i]);
          }

          return visibleCards;
        }

        function updateSlider() {
          const visibleCards = getVisibleCards();
          const isMobile = window.innerWidth < 768;
          const maxVisible = isMobile ? 2 : 5;
          const totalAvailable = cardItems.length;

          // No sliding needed if we have fewer cards than max visible
          if (cardItems.length <= maxVisible) {
            currentIndex = 0;
            wrapper.style.transform = 'translateX(0%)';
            prevBtn.style.opacity = '0.75';
            nextBtn.style.opacity = '0.75';
            prevBtn.style.pointerEvents = 'none';
            nextBtn.style.pointerEvents = 'none';
            return;
          }

          // Constrain current index - we can't slide if we don't have enough cards
          const maxIndex = Math.max(0, totalAvailable - maxVisible);
          currentIndex = Math.min(currentIndex, maxIndex);
          currentIndex = Math.max(currentIndex, 0);

          // Calculate transform - slide by full card width
          const cardWidth = 100 / maxVisible;
          const translateX = -(currentIndex * cardWidth);

          wrapper.style.transform = 'translateX(' + translateX + '%)';

          // Update button states
          prevBtn.style.opacity = currentIndex === 0 ? '0' : '1';
          nextBtn.style.opacity = currentIndex >= maxIndex ? '0' : '1';
          prevBtn.style.pointerEvents = currentIndex === 0 ? 'none' : 'auto';
          nextBtn.style.pointerEvents = currentIndex >= maxIndex ? 'none' : 'auto';

          updateProgressBar(container, cardItems, currentIndex);
        }

        function updateProgressBar(container, cardItems, currentIndex) {
          const isMobile = window.innerWidth < 768;
          if (!isMobile) return;

          const totalCards = cardItems.length;
          const maxVisible = 2; // mobile
          const maxIndex = totalCards - maxVisible;

          let progress;

          if (currentIndex === 0) {
            // On first load → already showing first 2 slides
            progress = (maxVisible / totalCards) * 100;
          } else {
            // After sliding
            progress = ((currentIndex + maxVisible) / totalCards) * 100;
          }

          const bar = container.querySelector('.slider-progress-bar');

          if (bar) {
            bar.style.width = `${progress}%`;
          }
        }

        function slideNext(e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          const isMobile = window.innerWidth < 768;
          const maxVisible = isMobile ? 2 : 5;
          const totalAvailable = cardItems.length;
          const maxIndex = Math.max(0, totalAvailable - maxVisible);

          if (currentIndex < maxIndex) {
            currentIndex += 1;
            updateSlider();
          }
        }

        function slidePrev(e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }

          if (currentIndex > 0) {
            currentIndex -= 1;
            updateSlider();
          }
        }

        // Event listeners - simplified approach
        nextBtn.addEventListener('click', slideNext);
        prevBtn.addEventListener('click', slidePrev);

        // Handle window resize
        let resizeTimeout;
        function handleResize() {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(updateSlider, 100);
        }
        window.addEventListener('resize', handleResize);

        // Initialize
        updateSlider();

        // Touch/swipe support for mobile
        let startX = 0;
        let endX = 0;
        let isSwiping = false;

        wrapper.addEventListener(
          'touchstart',
          function (e) {
            startX = e.touches[0].clientX;
            isSwiping = true;
          },
          { passive: true }
        );

        wrapper.addEventListener(
          'touchmove',
          function (e) {
            if (!isSwiping) return;
            // Prevent default to avoid scrolling conflicts
            const currentX = e.touches[0].clientX;
            const diff = Math.abs(startX - currentX);
            if (diff > 10) {
              e.preventDefault();
            }
          },
          { passive: false }
        );

        wrapper.addEventListener(
          'touchend',
          function (e) {
            if (!isSwiping) return;
            isSwiping = false;

            endX = e.changedTouches[0].clientX;
            const diff = startX - endX;

            if (Math.abs(diff) > 50) {
              // Minimum swipe distance
              if (diff > 0) {
                slideNext();
              } else {
                slidePrev();
              }
            }
          },
          { passive: true }
        );

        // Cleanup function for theme changes/reloads
        container._sliderCleanup = function () {
          window.removeEventListener('resize', handleResize);
          nextBtn.removeEventListener('click', slideNext);
          prevBtn.removeEventListener('click', slidePrev);
        };
      });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBestSellingSliders);
    } else {
      initBestSellingSliders();
    }

    // Re-initialize on theme section loads (for theme customizer)
    document.addEventListener('shopify:section:load', initBestSellingSliders);
  })();
  function updateTabShadows(container) {
    const wrapper = container.querySelector('.tabs-head');
    const leftShadow = container.querySelector('.tabs-head-shadow--left');
    const rightShadow = container.querySelector('.tabs-head-shadow--right');

    if (!wrapper || !leftShadow || !rightShadow) return;

    const scrollLeft = wrapper.scrollLeft;
    const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

    leftShadow.style.opacity = scrollLeft > 0 ? '1' : '0';
    rightShadow.style.opacity = scrollLeft < maxScroll ? '1' : '0';
  }

  // Initialize for all tab containers
  document.querySelectorAll('.tabs-head-container').forEach((container) => {
    const wrapper = container.querySelector('.tabs-head');

    // Initial shadow update
    updateTabShadows(container);

    // Update on scroll
    wrapper.addEventListener('scroll', () => {
      updateTabShadows(container);
    });

    // Optional: update on window resize
    window.addEventListener('resize', () => {
      updateTabShadows(container);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const wrappers = document.querySelectorAll('.blog-list-grid-wrapper');

    wrappers.forEach((wrapper) => {
      const grid = wrapper.querySelector('.blog-list-grid');
      const prevBtn = wrapper.querySelector('.carousel-prev');
      const nextBtn = wrapper.querySelector('.carousel-next');
      const progressBar = wrapper.querySelector('.carousel-progress-bar');

      if (!grid || !prevBtn || !nextBtn) return;
      let isProgrammaticScroll = false;

      const scrollToSnapPoint = (direction) => {
        const cards = Array.from(grid.querySelectorAll('.blog-card'));
        if (cards.length === 0) return;
        isProgrammaticScroll = true;

        const containerRect = grid.getBoundingClientRect();
        const currentScroll = grid.scrollLeft;

        let currentCardIndex = 0;
        let minDistance = Infinity;

        cards.forEach((card, index) => {
          const cardRect = card.getBoundingClientRect();
          const distance = Math.abs(cardRect.left - containerRect.left);
          if (distance < minDistance) {
            minDistance = distance;
            currentCardIndex = index;
          }
        });

        let targetCardIndex;
        if (direction === 'next') {
          targetCardIndex = Math.min(cards.length - 1, currentCardIndex + 1);
        } else {
          targetCardIndex = Math.max(0, currentCardIndex - 1);
        }

        const targetCard = cards[targetCardIndex];
        const targetPosition = targetCard.offsetLeft;

        grid.scrollLeft = targetPosition;

        updateButtonsImmediate();
        updateProgressImmediate();

        setTimeout(() => {
          isProgrammaticScroll = false;
        }, 150);
      };

      prevBtn.addEventListener('click', () => {
        scrollToSnapPoint('prev');
      });

      nextBtn.addEventListener('click', () => {
        scrollToSnapPoint('next');
      });

      const updateButtonsImmediate = () => {
        const screenWidth = window.innerWidth;
        const isDesktopCarousel = screenWidth > 768 && grid.classList.contains('desktop-view-carousel');
        const isMobileCarousel = screenWidth <= 768 && grid.classList.contains('mobile-view-carousel');
        const isCarousel = isDesktopCarousel || isMobileCarousel;

        if (isCarousel) {
          prevBtn.classList.add('show');
          nextBtn.classList.add('show');

          const scrollLeft = grid.scrollLeft;
          const scrollWidth = grid.scrollWidth;
          const clientWidth = grid.clientWidth;

          const isStart = scrollLeft <= 1;
          const isEnd = scrollLeft >= scrollWidth - clientWidth - 1;

          prevBtn.style.opacity = isStart ? '0.3' : '1';
          nextBtn.style.opacity = isEnd ? '0.3' : '1';
          prevBtn.disabled = isStart;
          nextBtn.disabled = isEnd;
        } else {
          prevBtn.classList.remove('show');
          nextBtn.classList.remove('show');
        }
      };

      const updateProgressImmediate = () => updateProgress();
      const updateButtons = () => {
        const screenWidth = window.innerWidth;
        const isDesktopCarousel = screenWidth > 768 && grid.classList.contains('desktop-view-carousel');
        const isMobileCarousel = screenWidth <= 768 && grid.classList.contains('mobile-view-carousel');
        const isCarousel = isDesktopCarousel || isMobileCarousel;

        if (isCarousel) {
          prevBtn.classList.add('show');
          nextBtn.classList.add('show');

          setTimeout(() => {
            const scrollLeft = grid.scrollLeft;
            const scrollWidth = grid.scrollWidth;
            const clientWidth = grid.clientWidth;

            const isStart = scrollLeft <= 1;
            const isEnd = scrollLeft >= scrollWidth - clientWidth - 1;

            prevBtn.style.opacity = isStart ? '0.3' : '1';
            nextBtn.style.opacity = isEnd ? '0.3' : '1';
            prevBtn.disabled = isStart;
            nextBtn.disabled = isEnd;
          }, 50);
        } else {
          prevBtn.classList.remove('show');
          nextBtn.classList.remove('show');
        }
      };

      const updateProgress = () => {
        if (progressBar && window.innerWidth <= 767) {
          const cards = grid.querySelectorAll('.blog-card');
          if (cards.length === 0) return;

          const maxScroll = grid.scrollWidth - grid.clientWidth;

          // Figure out how many cards are visible in the viewport
          const visibleCards = Math.round(grid.clientWidth / cards[0].offsetWidth);

          // Current "index" based on scroll
          const currentIndex = Math.round(grid.scrollLeft / cards[0].offsetWidth);

          // Progress should account for how many cards are shown
          const shownCards = currentIndex + visibleCards;
          const progress = (shownCards / cards.length) * 100;

          progressBar.style.width = `${progress}%`;
        }
      };

      setTimeout(() => {
        updateButtons();
        updateProgress();
      }, 200);

      // Modified scroll event listener that ignores programmatic scrolls
      grid.addEventListener('scroll', () => {
        if (!isProgrammaticScroll) {
          setTimeout(() => {
            updateButtons();
            updateProgress();
          }, 10);
        }
      });

      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          updateButtons();
          updateProgress();
        }, 200);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      const addToCartEl = document.querySelector('.bndlr-add-to-cart');
      const totalPriceEl = document.querySelector('.bndlr-total-price');

      if (addToCartEl && totalPriceEl) {
        const addToCartWidth = addToCartEl.offsetWidth;
        const newRightValue = addToCartWidth + 16;

        // Apply to .bndlr-total-price
        totalPriceEl.style.position = 'absolute';
      }
    }, 2000);
    document.querySelectorAll('.bundle-products-section-data').forEach(function (wrapper) {
      const target = wrapper.querySelector('.bundler-target-element');

      if (target) {
        // Initial check
        if (target.innerHTML.trim() === '') {
          wrapper.style.display = 'none';
        }

        // Watch for changes in target content
        const observer = new MutationObserver(() => {
          if (target.innerHTML.trim() !== '') {
            wrapper.style.display = ''; // reset display back
            observer.disconnect(); // stop observing once content is found
          }
        });

        observer.observe(target, { childList: true, subtree: true });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cable-academy-video-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initCableAcademySliders() {
      const sliderContainers = document.querySelectorAll('.cable-cademy-video-slider-container');

      sliderContainers.forEach((container) => {
        if (container.hasAttribute('data-slider-initialized')) return;
        container.setAttribute('data-slider-initialized', 'true');

        const wrapper = container.querySelector('.cable-cademy-video-slider');
        const progressBar = container.querySelector('.mobile-slider-progress-bar');
        const prevBtn = container.closest('.cable-cademy-video-list').querySelector('.slider-nav--prev');
        const nextBtn = container.closest('.cable-cademy-video-list').querySelector('.slider-nav--next');
        const items = wrapper ? Array.from(wrapper.children) : [];

        if (!wrapper || !prevBtn || !nextBtn || items.length === 0) return;

        const getVisibleCount = () => (window.innerWidth < 768 ? 1 : 4);
        let visibleCount = getVisibleCount();
        let currentIndex = 0;

        const updateArrows = () => {
          prevBtn.style.display = currentIndex > 0 ? 'block' : 'none';
          nextBtn.style.display = currentIndex + visibleCount < items.length ? 'block' : 'none';
        };

        function goToIndex(index, animate = true) {
          wrapper.style.transition = animate ? 'transform 0.4s ease' : 'none';
          const percent = -(100 / visibleCount) * index;
          wrapper.style.transform = `translateX(${percent}%)`;
          updateArrows();

          // Update progress bar for mobile
          if (progressBar && window.innerWidth < 768) {
            const progress = ((index + 1) / items.length) * 100;
            progressBar.style.width = `${Math.min(progress, 100)}%`;
          }
        }

        function slideNext() {
          if (currentIndex + visibleCount >= items.length) return;
          currentIndex++;
          goToIndex(currentIndex);
        }

        function slidePrev() {
          if (currentIndex <= 0) return;
          currentIndex--;
          goToIndex(currentIndex);
        }

        prevBtn.addEventListener('click', slidePrev);
        nextBtn.addEventListener('click', slideNext);

        // Touch swipe
        let startX = 0;
        wrapper.addEventListener(
          'touchstart',
          (e) => {
            startX = e.touches[0].clientX;
          },
          { passive: true }
        );

        wrapper.addEventListener(
          'touchend',
          (e) => {
            const diff = startX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 50) {
              if (diff > 0) slideNext();
              else slidePrev();
            }
          },
          { passive: true }
        );

        // Resize support
        window.addEventListener('resize', () => {
          visibleCount = getVisibleCount();
          goToIndex(currentIndex, false);
        });

        goToIndex(currentIndex, false);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCableAcademySliders);
    } else {
      initCableAcademySliders();
    }

    document.addEventListener('shopify:section:load', initCableAcademySliders);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["certification"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.certification-section-data');
    if (window.innerWidth <= 749 && el) {
      el.style.gap = el.dataset.gapMobile + 'px';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-us-map"] && !Shopify.designMode) return;
  try {
    
  function initMap() {
    const uluru = { lat: 39.167541105254784, lng: -94.43394414401645 };
    const map = new google.maps.Map(document.getElementById('map'), {
      zoom: 10,
      scaleControl: false,
      center: uluru,
    });
    const contentString =
      '<div id="content">' +
      '<div id="siteNotice">' +
      '</div>' +
      '<h1 id="firstHeading" class="firstHeading">Uluru</h1>' +
      '<div id="bodyContent">' +
      '<p><b>Uluru</b>, also referred to as <b>Ayers Rock</b>, is a large ' +
      'sandstone rock formation in the southern part of the ' +
      'Northern Territory, central Australia. It lies 335&#160;km (208&#160;mi) ' +
      'south west of the nearest large town, Alice Springs; 450&#160;km ' +
      '(280&#160;mi) by road. Kata Tjuta and Uluru are the two major ' +
      'features of the Uluru - Kata Tjuta National Park. Uluru is ' +
      'sacred to the Pitjantjatjara and Yankunytjatjara, the ' +
      'Aboriginal people of the area. It has many springs, waterholes, ' +
      'rock caves and ancient paintings. Uluru is listed as a World ' +
      'Heritage Site.</p>' +
      '</div>' +
      '</div>';
    const infowindow = new google.maps.InfoWindow({
      content: contentString,
      ariaLabel: 'Uluru',
    });
    const marker = new google.maps.Marker({
      position: uluru,
      map,
      title: 'Uluru (Ayers Rock)',
    });
  }

  window.initMap = initMap;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const isMobile = () => window.innerWidth <= 768;
    const main = document.querySelector("main");
    const crazyobserver = new MutationObserver(() => {
        const cta = document.querySelector("crazyegg-cta");

        if (cta) {
          main.appendChild(cta); // move inside <main>
          crazyobserver.disconnect(); // stop watching once done
        }
      });

      crazyobserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    // === CART POPUP ===
    const cartIconWrap = document.querySelector('.cart-icon-wrap');
    const cartPopup = document.getElementById('CartPopup');
    // Fetch the cart to check if it has items and user is not on mobile
    if(window.innerWidth > 1024){ 
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (cart && cart.items.length > 0 && cartPopup) {
            cartPopup.classList.remove('hidden'); // Remove hidden if cart has items
          }
        })
        .catch(err => console.error('Cart fetch error:', err));
      if (cartIconWrap && cartPopup) {
        cartIconWrap.addEventListener('mouseenter', () => {
          cartPopup.style.display = 'block';
          cartPopup.style.opacity = 1;
        });
  
        cartIconWrap.addEventListener('mouseleave', () => {
          cartPopup.style.opacity = 0;
          setTimeout(() => (cartPopup.style.display = 'none'), 150);
        });
        const cartCloseBtn = document.querySelector('.cart-popup-close');
        if (cartCloseBtn) {
          cartCloseBtn.addEventListener('click', () => {
            cartPopup.style.display = 'none';
          });
        }
      }
    }

    // === MEGAMENU LOGIC ===
    // Mouse (hover) and keyboard (focus) share the same open/close functions
    const menuItems = document.querySelectorAll('.menu-link-wrap');
    const menus = document.querySelectorAll('.megamenu-content');
    const headerNav = document.querySelector('.header-main-nav');
    let skipFocusOpen = false;

    const resetParentLinks = (scope) => {
      scope.querySelectorAll('.megamenu-data').forEach((menuData) => {
        const parentLinks = menuData.querySelectorAll('.menu-parent-link');
        if (parentLinks.length > 0) {
          parentLinks.forEach((l) => l.classList.remove('active'));
          parentLinks[0].classList.add('active');
        }
      });
    };

    const setExpanded = (item, expanded) => {
      const link = item.querySelector('.menu-link');
      if (link && item.classList.contains('has-megamenu')) {
        link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    };

    const openMenu = (item) => {
      const title = item.querySelector('.menu-link').textContent.trim();
      menuItems.forEach((i) => {
        i.classList.remove('active');
        setExpanded(i, false);
      });
      item.classList.add('active');
      setExpanded(item, true);
      menus.forEach((menu) => {
        menu.style.display = menu.dataset.parent === title ? 'block' : 'none';
      });
    };

    const closeMenus = () => {
      menus.forEach((menu) => (menu.style.display = 'none'));
      menuItems.forEach((item) => {
        item.classList.remove('active');
        setExpanded(item, false);
      });
      resetParentLinks(document);
    };

    menuItems.forEach((item) => {
      setExpanded(item, false);
      item.addEventListener('mouseenter', () => openMenu(item));
      item.addEventListener('focusin', () => {
        if (!skipFocusOpen && !item.classList.contains('active')) openMenu(item);
      });
    });

    menus.forEach((menu) => {
      menu.addEventListener('mouseenter', () => {
        const parentTitle = menu.dataset.parent;
        menuItems.forEach((item) => {
          const title = item.querySelector('.menu-link').textContent.trim();
          if (title === parentTitle) item.classList.add('active');
        });
        menu.style.display = 'block';
      });
    });

    if (headerNav) {
      headerNav.addEventListener('mouseleave', () => {
        // Keep the menu open if keyboard focus is still inside it
        if (headerNav.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) return;
        closeMenus();
      });

      // Close when keyboard focus leaves the nav entirely
      headerNav.addEventListener('focusout', (e) => {
        if (!headerNav.contains(e.relatedTarget) && !headerNav.matches(':hover')) closeMenus();
      });

      headerNav.addEventListener('keydown', (e) => {
        // Escape closes the open megamenu and returns focus to its top-level link
        if (e.key === 'Escape') {
          const openItem = headerNav.querySelector('.menu-link-wrap.has-megamenu.active');
          if (!openItem) return;
          skipFocusOpen = true;
          openItem.querySelector('.menu-link').focus();
          skipFocusOpen = false;
          closeMenus();
          return;
        }

        // ArrowDown on a top-level link opens its megamenu and moves focus to the first link inside
        if (e.key === 'ArrowDown' && e.target.matches('.menu-link-wrap.has-megamenu > .menu-link')) {
          e.preventDefault();
          const item = e.target.closest('.menu-link-wrap');
          openMenu(item);
          const firstLink = item.querySelector('.megamenu-content a');
          if (firstLink) firstLink.focus();
        }
      });
    }

    // === MEGAMENU INNER LINK RESET ===
    document.querySelectorAll('.megamenu-data').forEach((menuData) => {
      const parentLinks = menuData.querySelectorAll('.menu-parent-link');
      if (parentLinks.length > 0) {
        parentLinks[0].classList.add('active');
        parentLinks.forEach((link) => {
          const activate = () => {
            parentLinks.forEach((l) => l.classList.remove('active'));
            link.classList.add('active');
          };
          link.addEventListener('mouseenter', activate);
          link.addEventListener('focusin', activate);
        });
        const wrap = menuData.closest('.menu-link-wrap.has-megamenu');
        if (wrap) {
          wrap.addEventListener('mouseleave', function () {
            if (wrap.contains(document.activeElement) && document.activeElement.matches(':focus-visible')) return;
            parentLinks.forEach((l) => l.classList.remove('active'));
            parentLinks[0].classList.add('active');
          });
          wrap.addEventListener('focusout', (e) => {
            if (wrap.contains(e.relatedTarget) || wrap.matches(':hover')) return;
            parentLinks.forEach((l) => l.classList.remove('active'));
            parentLinks[0].classList.add('active');
          });
        }
      }
    });

    // === MOBILE MENU TOGGLE ===
    document.querySelectorAll('.mobile-menu-toggle').forEach((toggle) => {
      toggle.addEventListener('click', function () {
        const menuName = this.dataset.toggle;
        const submenu = document.querySelector(`.mobile-submenu[data-menu="${menuName}"]`);
        if (submenu) {
          const isVisible = submenu.style.display === 'block';
          submenu.style.display = isVisible ? 'none' : 'block';
          this.classList.toggle('open', !isVisible);
          const button = this.querySelector('.mobile-menu-toggle-button');
          if (button) button.setAttribute('aria-expanded', String(!isVisible));
        }
      });
    });

    // === HAMBURGER MENU ===
    const hamburger = document.querySelector('.hamburger-menu');
    if (hamburger) {
      const menu = document.querySelector('.header-menu-mobile');
      const icon = hamburger.querySelector('img');
      const header = document.querySelector('.header-main-nav');
      const isDrawerOpen = () => menu.style.display === 'block';

      const setDrawerOpen = (open) => {
        menu.style.display = open ? 'block' : 'none';
        header.classList.toggle('open', open);
        header.style.display = open ? 'block' : 'none';
        icon.src = open ? hamburger.dataset.openIcon : hamburger.dataset.closeIcon;
        document.body.classList.toggle('menu-open', open);
        hamburger.setAttribute('aria-expanded', String(open));
        hamburger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      };

      // The hamburger (close button) plus every visible focusable element in the drawer
      const getTrapElements = () => [
        hamburger,
        ...Array.from(menu.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
          .filter((el) => el.getClientRects().length > 0),
      ];

      hamburger.addEventListener('click', () => {
        const open = !isDrawerOpen();
        setDrawerOpen(open);
        if (open) {
          const firstItem = getTrapElements()[1];
          if (firstItem) firstItem.focus();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (!isDrawerOpen()) return;

        // Escape closes the drawer and returns focus to the hamburger
        if (e.key === 'Escape') {
          setDrawerOpen(false);
          hamburger.focus();
          return;
        }

        // Trap Tab / Shift+Tab inside the hamburger and drawer while it's open
        if (e.key === 'Tab') {
          e.preventDefault();
          const elements = getTrapElements();
          const index = elements.indexOf(document.activeElement);
          const step = e.shiftKey ? -1 : 1;
          const next = index === -1 ? 0 : (index + step + elements.length) % elements.length;
          elements[next].focus();
        }
      });
    }

    // === STICKY HEADER + WISEPOPS ===
    const headerWrapper = document.querySelector('.header-wrapper');
    const headerGroup = document.querySelector('#header-group');
    const mainNav = document.getElementById('main-navigation');
    const nav = document.querySelector('.header-main-nav');
    const WISE_ROOT_SELECTOR = '#wisepops-root-571777, .wisepops-root, crazyegg-cta';
    var lastAppliedTop = null;

    // --- Get total popup height ---
    const getWiseHeight = () => {
      const wise = document.querySelector(WISE_ROOT_SELECTOR);
      if (!wise) return 0;

      if (wise.tagName.toLowerCase() === 'crazyegg-cta') {
        const shadow = wise.shadowRoot;
        if (!shadow) return 0;

        const main = shadow.querySelector('#main');
        if (!main) return 0;

        return main.getBoundingClientRect().height || 0;
      }

      return wise.getBoundingClientRect().height || 0;
    };

    function adjustHeaderTop() {

      const wise = document.querySelector(WISE_ROOT_SELECTOR);
      const wiseHeight = getWiseHeight();
      const bannerExists = wiseHeight > 0;   // <--- THE IMPORTANT FIX

      const contentBody = document.querySelector('body');
      const headerWrapper = document.querySelector('.header-wrapper');
      const headerMain = headerWrapper.querySelector('.header-main');

      const headerMainHeight = headerMain?.offsetHeight ?? 0;
      const announcementHeight = headerWrapper.querySelector('.header-announcement')?.offsetHeight ?? 0;
      const SearchHeight = headerWrapper.querySelector('predictive-search')?.offsetHeight ?? 0;
      
      const scrollY = window.scrollY;
      const isSticky = headerMain.classList.contains('sticky');
      const isDesktop = !isMobile(); // <--- Desktop logic only when banner exists
      if (!headerWrapper) return;
      if (wise) {
        if (isDesktop){
          if (scrollY > announcementHeight){
            headerMain.style.top = `${wiseHeight}px`;
            headerMain.classList.add('sticky');
            nav.classList.add('sticky');
            contentBody.classList.add('contentPadding');
          } else {
            headerMain.style.top = '';
            headerMain.classList.remove('sticky');
            nav.classList.remove('sticky');
            contentBody.classList.remove('contentPadding');

          }
        } else {
          if (scrollY > (announcementHeight + wiseHeight)){
            headerMain.classList.add('sticky');
            nav.classList.add('sticky');
          } else {
            headerMain.classList.remove('sticky');
            nav.classList.remove('sticky');
          }
        }
      } else {
        if (scrollY > announcementHeight) {
          headerMain.classList.add('sticky');
          nav.classList.add('sticky');
          contentBody.classList.add('contentPadding');
        }else{
          headerMain.classList.remove('sticky');
          nav.classList.remove('sticky');
          contentBody.classList.remove('contentPadding');

        }
      }

      if (isSticky) {
        if (!isDesktop) {
          nav.style.top = (headerMainHeight - SearchHeight - 12) + "px";
        }
      } else {
        if (isDesktop) {
          if (wise){
            headerWrapper.style.paddingTop = `${wiseHeight}px`;
          }
        } else { 
          nav.style.top = (wiseHeight + announcementHeight + headerMainHeight - SearchHeight - 12) + "px";
          if (wise) {
            headerWrapper.style.paddingTop = `${wiseHeight}px`;
          }
        }
      }
    }

    // Debounce so logic doesn't rum so many times per second
    function debounce(func, wait = 50) {
      let timeout;
      return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    // === Sticky Scroll Behavior ===
    const debouncedAdjustHeaderTop = debounce(adjustHeaderTop);
    window.addEventListener('scroll', () => {
      debounce(adjustHeaderTop());
      // Tabbing through the megamenu can scroll the page, so keep it open while it has keyboard focus
      const focused = document.activeElement;
      if (headerNav && headerNav.contains(focused) && focused.matches(':focus-visible')) return;
      document.querySelectorAll('.menu-link-wrap.has-megamenu.active').forEach((i) => i.classList.remove('active'));
      document.querySelectorAll('.megamenu-content').forEach((m) => (m.style.display = 'none'));
    });

    // === Wisepops Observation ===
    const observer = new MutationObserver(adjustHeaderTop);
    observer.observe(document.body, { childList: true, subtree: true });

    const interval = setInterval(() => {
      const wise = document.querySelector(WISE_ROOT_SELECTOR);
      if (wise) {
        adjustHeaderTop();
        clearInterval(interval);
        new ResizeObserver(adjustHeaderTop).observe(wise);
      }
    }, 500);

    window.addEventListener('resize', () => {
      adjustHeaderTop();
    });

    // === Initial Run ===
    adjustHeaderTop();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function () {
    function addImageAttributes(img, desktop) {
      img.setAttribute('fetchpriority', 'high');
      if(desktop) {
        img.setAttribute('width', '768');
        img.setAttribute('height', '432');
      } else {
        img.setAttribute('width', '1920');
        img.setAttribute('height', '1080');
      }
    }

    const videoThumbnailMobile = document.querySelector('video.hero__video.hide-mobile img');
    const videoThumbnailDesktop = document.querySelector('video.hero__video.hide-desktop img');

    addImageAttributes(videoThumbnailMobile, false);
    addImageAttributes(videoThumbnailDesktop, true);
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plp-collection-list"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initPLPCollectionSliders() {
      const sliderContainers = document.querySelectorAll('.plp-collection-list-slider-container');

      sliderContainers.forEach(function (container) {
        // Skip if already initialized
        if (container.hasAttribute('data-slider-initialized')) return;
        container.setAttribute('data-slider-initialized', 'true');

        const wrapper = container.querySelector('.card-wrapper--slider');
        const prevBtn = container.querySelector('.slider-nav--prev');
        const nextBtn = container.querySelector('.slider-nav--next');
        const cardItems = wrapper ? wrapper.querySelectorAll('.card-collection') : [];

        if (!wrapper || !prevBtn || !nextBtn || cardItems.length === 0) return;

        let currentIndex = 0;

        // Get visible card items based on screen size
        function getVisibleCards() {
          const isMobile = window.innerWidth < 768;
          const maxCards = isMobile ? 2 : 5;
          const visibleCards = [];

          for (let i = 0; i < Math.min(cardItems.length, maxCards); i++) {
            visibleCards.push(cardItems[i]);
          }

          return visibleCards;
        }
        function updateSlider() {
          const isMobile = window.innerWidth < 768;
          const maxVisible = isMobile ? 2 : 5;
          const totalAvailable = cardItems.length;

          if (cardItems.length <= maxVisible) {
            currentIndex = 0;
            wrapper.style.transform = 'translateX(0px)';
            prevBtn.style.opacity = '0';
            nextBtn.style.opacity = '0';
            prevBtn.style.pointerEvents = 'none';
            nextBtn.style.pointerEvents = 'none';

            // Progress bar full if no scrolling
            updateProgress();
            return;
          }

          const maxIndex = Math.max(0, totalAvailable - maxVisible);
          currentIndex = Math.min(currentIndex, maxIndex);
          currentIndex = Math.max(currentIndex, 0);

          // Calculate transform - slide by full card width
          const card = document.querySelector('.plp-collection-list-slider-container collection-card');
          const cardWidth = card.offsetWidth + 20;
          const translateX = -(currentIndex * cardWidth);
          wrapper.style.transform = `translateX(${translateX}px)`;

          prevBtn.style.opacity = currentIndex === 0 ? '0' : '1';
          nextBtn.style.opacity = currentIndex >= maxIndex ? '0' : '1';
          prevBtn.style.pointerEvents = currentIndex === 0 ? 'none' : 'auto';
          nextBtn.style.pointerEvents = currentIndex >= maxIndex ? 'none' : 'auto';

          // Update progress bar here
          updateProgress();
        }
        function updateProgress() {
          const progressBar = container.querySelector('#plp-collection-progress .progress-bar');
          if (!progressBar) return;

          const isMobile = window.innerWidth < 768;
          const maxVisible = isMobile ? 2 : 5;
          const totalAvailable = cardItems.length;
          const maxIndex = Math.max(0, totalAvailable - maxVisible);

          // Handle edge case: not scrollable
          if (maxIndex === 0) {
            progressBar.style.width = '100%';
            return;
          }

          const progress = ((currentIndex + 1) / (maxIndex + 1)) * 100;
          progressBar.style.width = `${progress}%`;
        }

        function slideNext(e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          const isMobile = window.innerWidth < 768;
          const maxVisible = isMobile ? 2 : 5;
          const totalAvailable = cardItems.length;
          const maxIndex = Math.max(0, totalAvailable - maxVisible);

          if (currentIndex < maxIndex) {
            currentIndex += 1;
            updateSlider();
          }
        }

        function slidePrev(e) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }

          if (currentIndex > 0) {
            currentIndex -= 1;
            updateSlider();
          }
        }

        // Event listeners - simplified approach
        nextBtn.addEventListener('click', slideNext);
        prevBtn.addEventListener('click', slidePrev);

        // Handle window resize
        let resizeTimeout;
        function handleResize() {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(updateSlider, 100);
        }
        window.addEventListener('resize', handleResize);

        // Initialize
        updateSlider();

        // Touch/swipe support for mobile
        let startX = 0;
        let endX = 0;
        let isSwiping = false;

        wrapper.addEventListener(
          'touchstart',
          function (e) {
            startX = e.touches[0].clientX;
            isSwiping = true;
          },
          { passive: true }
        );

        wrapper.addEventListener(
          'touchmove',
          function (e) {
            if (!isSwiping) return;
            // Prevent default to avoid scrolling conflicts
            const currentX = e.touches[0].clientX;
            const diff = Math.abs(startX - currentX);
            if (diff > 10) {
              e.preventDefault();
            }
          },
          { passive: false }
        );

        wrapper.addEventListener(
          'touchend',
          function (e) {
            if (!isSwiping) return;
            isSwiping = false;

            endX = e.changedTouches[0].clientX;
            const diff = startX - endX;

            if (Math.abs(diff) > 50) {
              // Minimum swipe distance
              if (diff > 0) {
                slideNext();
              } else {
                slidePrev();
              }
            }
          },
          { passive: true }
        );

        // Cleanup function for theme changes/reloads
        container._sliderCleanup = function () {
          window.removeEventListener('resize', handleResize);
          nextBtn.removeEventListener('click', slideNext);
          prevBtn.removeEventListener('click', slidePrev);
        };
      });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPLPCollectionSliders);
    } else {
      initPLPCollectionSliders();

      const expand = document.querySelector('.expand-desc');
      const desc = document.querySelector('#section-desc');

      expand.addEventListener('click', function () {
        if (expand.innerText === 'Expand') {
          desc.classList.remove('section-description');
          expand.innerText = 'Reduce';
        } else {
          desc.classList.add('section-description');
          expand.innerText = 'Expand';
        }
      });
    }

    // Re-initialize on theme section loads (for theme customizer)
    document.addEventListener('shopify:section:load', initPLPCollectionSliders);

    document.addEventListener('DOMContentLoaded', function () {
      const progressSlider = document.querySelector('#plp-collection-progress .progress-bar');
      const slides = document.querySelectorAll('.plp-collection-list .card-wrapper--slider .card-collection');
      const slider = document.querySelector('.plp-collection-list .card-wrapper--slider');

      const totalToScroll = slides.length - 2;
      const totalTransform = totalToScroll * -55;
      let currentTransform = 0;

      // Default value
      let defaultPercentage = 2 / slides.length;
      // progressSlider.style.width = `${defaultPercentage * 100}%`;

      // Trigger change
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'style') {
            const transformValue = slider.style.transform.match(/\((.*?)\)/)[1].slice(0, -1);
            currentTransform = Number(transformValue);

            if (currentTransform === 0 || currentTransform === -0) {
              progressSlider.style.width = `${defaultPercentage * 100}%`;
            } else {
              const updatedPercentage = (currentTransform + -110) / (totalTransform + -110);
              progressSlider.style.width = `${updatedPercentage * 100}%`;
            }
          }
        });
      });

      observer.observe(slider, { attributes: true, attributeFilter: ['style'] });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    let triggerCarousel = false;

    // Logic for fetching recently viewed products
    function initFetchRecentlyViewedProducts() {
      const container = document.getElementById('recently-viewed-container');
      const containerMobile = document.getElementById('recently-viewed-container-mobile');

      const handles = JSON.parse(localStorage.getItem('recent_products')) || [];

      if (handles.length === 0) {
        container.innerHTML = '<p>No recently viewed products.</p>';
        return;
      }

      Promise.all(
        handles.map((handle) =>
          fetch(`/products/${handle.handle}.js`)
            .then((res) => {
              if (!res.ok) throw new Error(`Failed to fetch ${handle}`);
              return res.text();
            })
            .then((text) => {
              if (!text) throw new Error(`Empty response for ${handle}`);
              return JSON.parse(text);
            })
            .catch((err) => {
              console.warn(`Skipping ${handle}:`, err);
              return null; // skip failed products
            })
        )
      )
        .then((products) => {
          const validProducts = products.filter((p) => p !== null);

          if (validProducts.length === 0) {
            container.innerHTML = '<p>No valid recently viewed products.</p>';
            containerMobile.innerHTML = '<p>No valid recently viewed products.</p>';
            return;
          }

          container.innerHTML = validProducts
            .slice(0, 8)
            .map(
              (product) => `
            <product-card class="product-card">
              <a
                class="product-card__url flex-column gap-8"
                alt="Go to product page for ${product.title}"
                ref="productCardLink"
                href="${product.url}">
                <div class="product-card__image border-neutral-faded">
                  <img src="${product.featured_image}" alt="Featured image for ${product.title}"  width="93" height="93" />
                </div>
                <p class="body-3 font-600 text-neutral-faded">${product.title}</p>
                <div class="product-card__fixed-items">
                  <p class="body-3 font-600 text-neutral-faded">From $${(product.price_min / 100).toFixed(2)}</p>
                </div>
              </a>
            </product-card>
        `
            )
            .join('');

          containerMobile.innerHTML = validProducts
            .slice(0, 8)
            .map(
              (product, index) => `
            <product-card class="product-card" data-card-index="${index}">
              <a
                class="product-card__url flex-column gap-8"
                alt="Go to product page for ${product.title}"
                ref="productCardLink"
                href="${product.url}">
                <div class="product-card__image border-neutral-faded">
                  <img src="${product.featured_image}" alt="Featured image for ${product.title}"  width="93" height="93" />
                </div>
                <p class="body-3 font-600 text-neutral-faded">${product.title}</p>
                <div class="product-card__fixed-items">
                  <p class="body-3 font-600 text-neutral-faded">$${(product.price / 100).toFixed(2)}</p>
                </div>
              </a>
            </product-card>
        `
            )
            .join('');
        })
        .finally(() => {
          initProductListSliders();
          initProductListProgressBar(null, []);
        });
    }

    function initProductListProgressBar(wrapper = null, slides = []) {
      const progressSlider = document.querySelector('.recently-viewed-progress .progress-bar');
      if (!progressSlider || slides.length === 0) return;

      function updateProgress(currentIndex, maxVisible) {
        const totalAvailable = slides.length;
        const maxIndex = Math.max(0, totalAvailable - maxVisible);

        if (maxIndex === 0) {
          progressSlider.style.width = '100%';
          return;
        }

        const percentage = ((currentIndex + maxVisible) / totalAvailable) * 100;
        progressSlider.style.width = `${percentage}%`;
      }

      return updateProgress;
    }

    function initProductListSliders() {
      const sliderContainers = document.querySelectorAll('.product-list-recently-viewed-slider-container');

      sliderContainers.forEach(function (container) {
        if (container.hasAttribute('data-slider-initialized')) return;
        container.setAttribute('data-slider-initialized', 'true');

        const wrapper = container.querySelector('.card-wrapper--slider');
        const prevBtn = container.querySelector('.slider-nav--prev');
        const nextBtn = container.querySelector('.slider-nav--next');
        const cardItems = JSON.parse(localStorage.getItem('recent_products')) || [];

        if (!wrapper || !prevBtn || !nextBtn || cardItems.length === 0) return;

        let currentIndex = 0;
        const updateProgress = initProductListProgressBar(wrapper, cardItems);

        function updateSlider() {
          const isMobile = window.innerWidth < 768;
          const maxVisible = isMobile ? 2 : 5;
          const totalAvailable = cardItems.length;

          if (totalAvailable <= maxVisible) {
            wrapper.style.transform = 'translateX(0px)';
            prevBtn.style.opacity = '0';
            prevBtn.style.pointerEvents = 'none';
            nextBtn.style.opacity = '0';
            nextBtn.style.pointerEvents = 'none';
            updateProgress(currentIndex, maxVisible);
            return;
          }

          const maxIndex = Math.max(0, totalAvailable - maxVisible);
          currentIndex = Math.min(currentIndex, maxIndex);

          const card = document.querySelector('.product-list-recently-viewed-mobile product-card');
          const cardWidth = card.offsetWidth + 20;
          const translateX = -(currentIndex * cardWidth);
          wrapper.style.transform = `translateX(${translateX}px)`;

          prevBtn.style.opacity = currentIndex === 0 ? '0' : '1';
          prevBtn.style.pointerEvents = currentIndex === 0 ? 'none' : 'auto';
          nextBtn.style.opacity = currentIndex >= maxIndex ? '0' : '1';
          nextBtn.style.pointerEvents = currentIndex >= maxIndex ? 'none' : 'auto';

          // ✅ Update progress bar here
          updateProgress(currentIndex, maxVisible);
        }

        // same event listeners as before...
        nextBtn.addEventListener('click', () => {
          currentIndex++;
          updateSlider();
        });

        prevBtn.addEventListener('click', () => {
          currentIndex--;
          updateSlider();
        });

        /* -------------------------------
            TOUCH / SWIPE (MOBILE)
        -------------------------------- */
        let startX = 0;
        let currentTranslate = 0;
        let dragging = false;

        wrapper.addEventListener('touchstart', (e) => {
          dragging = true;
          startX = e.touches[0].clientX;
          wrapper.style.transition = 'none';
        });

        wrapper.addEventListener('touchmove', (e) => {
          if (!dragging) return;

          const isMobile = window.innerWidth < 768;
          const maxVisible = isMobile ? 2 : 5;

          const card = wrapper.querySelector('.product-card');
          const cardWidth = card.offsetWidth + 20;

          const diff = e.touches[0].clientX - startX;
          wrapper.style.transform = `translateX(${ -(currentIndex * cardWidth) + diff }px)`;
        });

        wrapper.addEventListener('touchend', (e) => {
          dragging = false;
          wrapper.style.transition = 'transform 0.3s ease';

          const diff = e.changedTouches[0].clientX - startX;

          const threshold = 50; // min swipe distance
          const isMobile = window.innerWidth < 768;
          const maxVisible = isMobile ? 2 : 5;
          const total = cardItems.length;
          const maxIndex = Math.max(0, total - maxVisible);

          if (diff < -threshold && currentIndex < maxIndex) {
            currentIndex++;
          } else if (diff > threshold && currentIndex > 0) {
            currentIndex--;
          }

          updateSlider();
        });


        updateSlider();
      });
    }

    const typeOfCarousel = document.querySelector('section.product-list-recently-viewed').dataset.type;

    // typeOfCarousel !== 'recently-viewed'

    if (typeOfCarousel === 'recently-viewed') {
      // Initialize when DOM is ready)
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFetchRecentlyViewedProducts);
      } else {
        initFetchRecentlyViewedProducts();
      }

      // Re-initialize on theme section loads (for theme customizer)
      document.addEventListener('DOMContentLoaded', initFetchRecentlyViewedProducts);
    }

    if (typeOfCarousel !== 'recently-viewed') {
      // Recommended products
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsSection);

        const url = productRecommendationsSection.dataset.url;

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-list-recently-viewed');

            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            initProductListSliders();
            initProductListProgressBar(null, []);
          });
      };

      const productRecommendationsSection = document.querySelector('.product-list-recently-viewed');
      const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

      observer.observe(productRecommendationsSection);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
  const closeModal = () => {
    const modal = document.querySelector('.stamped-ugc-modal.open');
    if (modal) {
      modal.classList.remove('open');
      modal.style.display = 'none';
    }
  };

  document.addEventListener('click', (e) => {
    const modal = document.querySelector('.stamped-ugc-modal.open');
    if (!modal) return;

    const wrapper = modal.querySelector('.stamped-ugc-modal-wrapper');
    if (!wrapper.contains(e.target)) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeModal();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
